function sliderEngineering() {
    var swiper = new Swiper('.engineering .mySwiper', {
        slidesPerView: 2,
        spaceBetween: 90,
        speed: 500,
        pagination: {
            el: ".engineering .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            577: {
                slidesPerView: 1.5,
                spaceBetween: 40,
            },
            993: {
                slidesPerView: 2,
                spaceBetween: 90,
            }
        }
    })
}

function sliderArchitecture() {
    return new Swiper('.architecture .mySwiper', {
        slidesPerView: 1,
        spaceBetween: 45,
        speed: 500,
        navigation: {
            nextEl: ".architecture .swiper-button-next",
            prevEl: ".architecture .swiper-button-prev",
        },
        pagination: {
            el: ".architecture .swiper-pagination",
            clickable: true,
        },
    });
}

function sliderFormats() {
    var swiper = new Swiper('.formats .mySwiper', {
        slidesPerView: 3,
        spaceBetween: 10,
        speed: 500,
        pagination: {
            el: ".formats .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            577: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 10,
            }
        }
    })
}

function sliderNews() {
    var swiper = new Swiper('.news .mySwiper', {
        slidesPerView: 3,
        spaceBetween: 10,
        speed: 500,
        pagination: {
            el: ".news .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            577: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            993: {
                slidesPerView: 3,
                spaceBetween: 10,
            }
        }
    })
}


$(document).ready(function () {
    sliderEngineering();
    sliderArchitecture();
    sliderFormats();
    sliderNews();

    // Burger
    $('.burger').click(function () {
        $('.burger').toggleClass('burger--active')
        $('.header-menu').toggleClass('header-menu--active')
        $('body').toggleClass('fixed-body')
    })

    $('.header-menu__list li a').click(function () {
        $('.burger').removeClass('burger--active')
        $('.header-menu').removeClass('header-menu--active')
        $('body').removeClass('fixed-body')
    })

    // Fancybox
    Fancybox.bind("[data-fancybox]", {});

    // Select
    $('.nice-select').niceSelect();

    // Modal
    $("[data-modal]").click(function () {
        let modalId = $(this).attr("data-modal")

        openModal(modalId)
    })

    function openModal(modalId){
        $(`#${modalId}`).addClass("modal--active")
        $("body").addClass("fixed-body")
    }

    $(".modal").click(function () {
        closeModal()
    })

    $("._close-modal").click(function () {
        closeModal()
    })

    $(".modal__dialog").click(function (e) {
        e.stopPropagation()
    })

    function closeModal() {
        $('.modal--active video').each(function () {
            this.pause();
            this.currentTime = 0;
        });

        $('.modal').removeClass("modal--active")
        $("body").removeClass("fixed-body")
    }
})

// Scroll
const plan = document.querySelector('.plan__wrap');
const planInner = document.querySelector('.plan__inner');

const scroll = document.querySelector('.scroll');
const scrollInner = document.querySelector('.scroll__inner');

function update() {
    scrollInner.style.width = planInner.scrollWidth + 'px';
}

update();
window.addEventListener('resize', update);

function syncScrollToPlan() {
    const maxPlan = plan.scrollWidth - plan.clientWidth;
    const maxScroll = scroll.scrollWidth - scroll.clientWidth;

    if (maxScroll <= 0) return;

    plan.scrollLeft = (scroll.scrollLeft / maxScroll) * maxPlan;
}

function syncPlanToScroll() {
    const maxPlan = plan.scrollWidth - plan.clientWidth;
    const maxScroll = scroll.scrollWidth - scroll.clientWidth;

    if (maxPlan <= 0) return;

    scroll.scrollLeft = (plan.scrollLeft / maxPlan) * maxScroll;
}

scroll.addEventListener('scroll', syncScrollToPlan);
plan.addEventListener('scroll', syncPlanToScroll);